import { MovesEnum } from 'shared/constants/shared-enums';

import paperNotActive from 'assets/png/moves/paper-not-active.png?format=webp;avif&as=picture';
import paper from 'assets/png/moves/paper.png?format=webp;avif&as=picture';
import stoneNotActive from 'assets/png/moves/rock-not-active.png?format=webp;avif&as=picture';
import stone from 'assets/png/moves/rock.png?format=webp;avif&as=picture';
import scissorsNotActive from 'assets/png/moves/scissors-not-active.png?format=webp;avif&as=picture';
import scissors from 'assets/png/moves/scissors.png?format=webp;avif&as=picture';

export const MOVES = [
  {
    type: MovesEnum.Rock,
    img: stone,
    imgNotActive: stoneNotActive,
    translationKey: 'common.rock',
  },
  {
    type: MovesEnum.Paper,
    img: paper,
    imgNotActive: paperNotActive,
    translationKey: 'common.paper',
  },
  {
    type: MovesEnum.Scissors,
    img: scissors,
    imgNotActive: scissorsNotActive,
    translationKey: 'common.scissors',
  },
];
